import { Button } from "@/components/ui/button";
import { Loader2, AlertTriangle, RotateCcw } from "lucide-react";

export function ReportError({ onRetry }) {
  return (
    <div className="border border-red-200 bg-red-50 rounded-md p-8 flex flex-col items-center gap-3 text-center" data-testid="report-error">
      <AlertTriangle className="h-8 w-8 text-red-500" />
      <p className="text-red-700 font-medium">Raportul nu a putut fi calculat.</p>
      <p className="text-sm text-red-600 max-w-md">
        A apărut o eroare de server la generarea acestui raport. Verificați parametrii și încercați din nou.
      </p>
      <Button onClick={onRetry} variant="outline" className="gap-2 border-red-300 text-red-700 hover:bg-red-100" data-testid="report-retry-btn">
        <RotateCcw className="h-4 w-4" /> Reîncearcă
      </Button>
    </div>
  );
}

export function ReportLoading({ label = "Se calculează raportul…" }) {
  return (
    <div className="border rounded-md p-10 flex flex-col items-center justify-center gap-3 text-slate-500" data-testid="report-loading">
      <Loader2 className="h-7 w-7 animate-spin text-slate-400" />
      <p className="text-sm">{label}</p>
    </div>
  );
}
